module.exports = __webpack_public_path__ + "images/FUSA_icons/096-list.214ccdcb5ba29641a414bd0b882888f1.svg";